import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import {Link} from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import {executeBackendQuery} from "../../requests/executeBackendQuery";
import {TENANTS_LIST, TENANTS_LIST_COUNT} from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import {buildServerQuery, applyClientSort} from "../../sort-utils";

const limit = 50;

export default class TenantList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };
    }

    componentDidMount() {
        this.fetch(this.props.location.query);
    }

    fetch(q) {
        this.setState({isBusy: true});

        const query = {...q};
        const options = filter(buildServerQuery(query), 'tenants');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        Promise.all([
            executeBackendQuery({queryName: TENANTS_LIST, options: options}),
            executeBackendQuery({queryName: TENANTS_LIST_COUNT, options: options})
        ]).then(res => {
            this.setState({
                items: applyClientSort(res[0].data, query.order),
                totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
                error: res[0].success ? null : res[0].message,
                isBusy: null,
            });
        });
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    render() {
        const query = this.props.location.query;

        const columns = [
            {
                name: 'View',
                textAlign: 'center',
                columnStyle: {width: 70},
                render: (el) => (
                    <Link to={{pathname: `${arc.path.base}tenant/${el.ARCIMEDES_ROW_ID}`}}><Icon svg={svgEdit}/></Link>
                ),
            },
            {
                code: 'NAME',
                name: 'Tenant',
                render: (el) => el.NAME,
            },
        ];

        return (
            <div className='TenantList' data-is-busy={this.state.isBusy}>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container list'>
                        <div className='page-header list'>
                            <div className='page-title'>Tenants</div>
                            <LinkComp to={`${arc.path.base}tenant`}>
                                <div className="button-new plus positive">
                                    <Icon svg={plus}/>
                                </div>
                            </LinkComp>
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='page-body-container'>
                    <SortTable columns={columns}
                               items={this.state.items}
                               query={query}
                    />
                    <ListResults query={this.props.location.query}
                                 pathname={this.props.location.pathname}
                                 error={this.state.error}
                                 totalCount={this.state.totalCount}
                                 itemCount={this.state.items ? this.state.items.length : false}
                                 limit={limit}
                    />
                </div>
            </div>
        );
    }
}
